export const AboutusData = [
    {
        id: 0,
        name: "Client-Centric",
        desc: "Our client is our hero :) Your vision, our mission. Dedicated to turning your ideas into digital success stories.",
        icon: "",
    },
    {
        id: 1,
        name: "Technical Expertise",
        desc: "Harnessing the latest technologies and best practices to deliver high-quality, efficient, and innovative solutions in wide-ranging fields",
        icon: "",
    },
    {
        id: 2,
        name: "Creative Excellence",
        desc: "Innovation at the heart of design, where every pixel tells a story and every line of code matters",
        icon: "",
    },
]